let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    matchedCount = 0,
    draggedElement = null,
    totalPairs = 0;

class MatchGame {
    constructor() {
        this.playScreen = document.querySelector('.game__match-play');
        this.resultScreen = document.querySelector('[data-phase="result"]');
        this.itemsContainer = document.querySelector('[data-items-container]');
        this.targetsContainer = document.querySelector('[data-targets-container]');
        this.matchedCountEl = document.querySelector('[data-matched-count]');
        this.modal = document.querySelector('[data-explanation-modal]');

        // Pobierz dane z window
        if (window.matchGameData) {
            gameData = window.matchGameData;
            totalPairs = gameData.pairs.length;
        }

        this.init();
    }

    init() {
        this.setupDragAndDrop();
        this.setupModal();
    }

    setupDragAndDrop() {
        // Items - draggable
        const items = this.itemsContainer.querySelectorAll('.match-item');
        items.forEach(item => {
            item.addEventListener('dragstart', (e) => this.handleDragStart(e, item));
            item.addEventListener('dragend', (e) => this.handleDragEnd(e, item));
        });

        // Targets - dropzones
        const targets = this.targetsContainer.querySelectorAll('.match-target');
        targets.forEach(target => {
            const dropzone = target.querySelector('[data-dropzone]');

            dropzone.addEventListener('dragover', (e) => this.handleDragOver(e));
            dropzone.addEventListener('dragenter', (e) => this.handleDragEnter(e, dropzone));
            dropzone.addEventListener('dragleave', (e) => this.handleDragLeave(e, dropzone));
            dropzone.addEventListener('drop', (e) => this.handleDrop(e, target));
        });
    }

    handleDragStart(e, item) {
        if (item.dataset.matched === 'true') {
            e.preventDefault();
            return;
        }

        draggedElement = item;
        item.classList.add('dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', item.innerHTML);

        // Dźwięk podniesienia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 500);
        }
    }

    handleDragEnd(e, item) {
        item.classList.remove('dragging');
    }

    handleDragOver(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.dataTransfer.dropEffect = 'move';
        return false;
    }

    handleDragEnter(e, dropzone) {
        const target = dropzone.closest('.match-target');
        if (target.dataset.matched === 'false') {
            dropzone.classList.add('drag-over');
        }
    }

    handleDragLeave(e, dropzone) {
        dropzone.classList.remove('drag-over');
    }

    handleDrop(e, target) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        e.preventDefault();

        const dropzone = target.querySelector('[data-dropzone]');
        dropzone.classList.remove('drag-over');

        if (!draggedElement || target.dataset.matched === 'true') {
            return false;
        }

        const itemId = draggedElement.dataset.itemId;
        const targetId = target.dataset.targetId;

        // Sprawdź czy dopasowanie poprawne
        if (itemId === targetId) {
            this.handleCorrectMatch(draggedElement, target, dropzone);
        } else {
            this.handleWrongMatch(draggedElement);
        }

        return false;
    }

    handleCorrectMatch(item, target, dropzone) {
        // Oznacz jako dopasowane
        item.dataset.matched = 'true';
        target.dataset.matched = 'true';

        // Usuń placeholder
        const placeholder = dropzone.querySelector('.dropzone-placeholder');
        if (placeholder) {
            placeholder.remove();
        }

        // Przenieś element do dropzone
        item.classList.add('matched');
        item.classList.remove('dragging');
        item.draggable = false;
        dropzone.appendChild(item);

        // Animacja sukcesu
        dropzone.classList.add('correct-match');
        setTimeout(() => {
            dropzone.classList.remove('correct-match');
        }, 600);

        // Dźwięk sukcesu
        if (audio && audio.valid) {
            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 1000);
        }

        // Flash zielony
        gameFrame.style.borderColor = 'green';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);

        // Aktualizuj licznik
        matchedCount++;
        if (this.matchedCountEl) {
            this.matchedCountEl.textContent = matchedCount;
        }

        // Pokaż wyjaśnienie
        const pairData = gameData.pairs.find(p => p.id == item.dataset.itemId);
        if (pairData) {
            setTimeout(() => {
                this.showExplanation(pairData);
            }, 500);
        }

        // Sprawdź czy koniec gry
        if (matchedCount === totalPairs) {
            setTimeout(() => {
                this.endGame();
            }, 2000);
        }
    }

    handleWrongMatch(item) {
        // Animacja błędu
        item.classList.add('wrong-shake');
        setTimeout(() => {
            item.classList.remove('wrong-shake');
        }, 500);

        // Dźwięk błędu
        if (audio && audio.wrong) {
            audio.wrong.play();
            stopAudioAfterDelay(audio.wrong, 1000);
        }

        // Flash czerwony
        gameFrame.style.borderColor = 'red';
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
        }, 500);
    }

    showExplanation(pairData) {
        if (!this.modal) return;

        const modalTitle = this.modal.querySelector('[data-modal-title]');
        const modalExplanation = this.modal.querySelector('[data-modal-explanation]');

        if (modalTitle) {
            modalTitle.textContent = 'Brawo! Poprawne dopasowanie!';
        }
        if (modalExplanation) {
            modalExplanation.textContent = pairData.explanation;
        }

        this.modal.classList.remove('hidden');
    }

    setupModal() {
        if (!this.modal) return;

        const closeButtons = this.modal.querySelectorAll('[data-modal-close]');
        closeButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.modal.classList.add('hidden');
            });
        });
    }

    endGame() {
        // Ukryj ekran gry
        if (this.playScreen) {
            this.playScreen.classList.add('hidden');
        }

        // Pokaż ekran wyniku
        if (this.resultScreen) {
            this.resultScreen.classList.remove('hidden');
        }

        // Dźwięk zakończenia
        if (audio && audio.success) {
            audio.success.play();
            stopAudioAfterDelay(audio.success, 3000);
        }
    }

    restart() {
        // Reset zmiennych
        matchedCount = 0;
        draggedElement = null;

        if (this.matchedCountEl) {
            this.matchedCountEl.textContent = '0';
        }

        // Reset ekranów
        if (this.playScreen) {
            this.playScreen.classList.remove('hidden');
        }
        if (this.resultScreen) {
            this.resultScreen.classList.add('hidden');
        }
        if (this.modal) {
            this.modal.classList.add('hidden');
        }

        // Reset elementów
        const items = this.itemsContainer.querySelectorAll('.match-item');
        items.forEach(item => {
            item.dataset.matched = 'false';
            item.classList.remove('matched', 'dragging', 'wrong-shake');
            item.draggable = true;

            // Przenieś z powrotem do kontenera items
            if (item.parentElement !== this.itemsContainer) {
                this.itemsContainer.appendChild(item);
            }
        });

        // Reset celów
        const targets = this.targetsContainer.querySelectorAll('.match-target');
        targets.forEach(target => {
            target.dataset.matched = 'false';
            const dropzone = target.querySelector('[data-dropzone]');
            dropzone.classList.remove('correct-match', 'drag-over');

            // Dodaj placeholder jeśli nie ma
            if (!dropzone.querySelector('.dropzone-placeholder')) {
                const placeholder = document.createElement('div');
                placeholder.className = 'dropzone-placeholder';
                placeholder.innerHTML = '<i class="fa fa-arrows"></i>';
                dropzone.appendChild(placeholder);
            }
        });

        // Przemieszaj items
        const itemsArray = Array.from(items);
        for (let i = itemsArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            this.itemsContainer.appendChild(itemsArray[j]);
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--match');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new MatchGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-match.js